import { MapLayouts } from '@components/MapView/types/mapView.types';
import { appConfig as tamaguiConfig } from '../../../tamagui.config';

export const DEFAULT_ZOOM_LEVEL = 1;
export const MIN_ZOOM_LEVEL = 0;

export const MAP_CLUSTER_LAYOUTS: MapLayouts = {
  CIRCLE_COLOR: [
    'step',
    ['get', 'point_count'],
    tamaguiConfig.tokens?.color?.secondary?.val,
    100,
    tamaguiConfig.tokens?.color?.brand?.val,
  ],
  CIRCLE_RADIUS: ['step', ['get', 'point_count'], 15, 100, 30, 750, 40],
};
